import FocusManager from './utils/focus-manager';
import ScrollManager from './utils/scroll-manager';

export default function initHeader()
{
    new Header(document.getElementById('main-header'));
}

/**
 * @param {HTMLElement} $el HTML Element header
 * @param {HTMLButtonElement} $menuToggler Toggler du menu
 * @param {HTMLElement} $mainHeaderNav Le menu principal
 * @param {HTMLElement} $mainHeaderPhoneNav Le menu retour pour mobile
 * @param {integer} mobileBreakpoint Breakpoint mobile
 * @param {string} initializedDevice Nom du device initialisé (mobile | desktop)
 * @param {Function} mobileClickMenuTogglerHandler Fonction à éxécuter au clique sur le toggler du menu
 * @param {Function} mobileKeyDownDocumentHandler Fonction à éxécuter à l'appuie sur une touche du clavier
 * @param {Function} mobileClickMainHeaderPhoneNavHandler Fonction à éxécuter au clique sur le bouton retour
 * @param {HTMLElement[]} $openedPanels Liste des panneaux ouverts
 */
class Header {
    constructor($el)
    {
        this.$el = $el;
        this.$menuToggler = $el.querySelector('.js-main-header-toggler');
        this.$mainHeaderNav = $el.querySelector('.js-main-header-nav');
        this.$mainHeaderPhoneNav = $el.querySelector('.js-main-header-phone-nav');
        this.mobileBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-main-header'));
        this.$openedPanels = [];
        this.initializedDevice = null;

        // pas de gestion du header sur les pages avec le template simple-page.php
        const body = document.querySelector('body');
        const bodyHasClassSimplePage = body.classList.contains('page-template-simple-page');

        if(!bodyHasClassSimplePage) {
            this.init();
            window.addEventListener('resize', this.init.bind(this));
        }

    }

    /**
     * Initialise le header dans le bon device en fonction
     * de la taille de l'écran (mobile ou desktop)
     * 
     * @return {void}
     */
    init()
    {
        if (window.innerWidth < this.mobileBreakpoint && this.initializedDevice !== 'mobile') {
            this.initMobile();
        } else if (window.innerWidth >= this.mobileBreakpoint && this.initializedDevice !== 'desktop') {
            this.initDesktop();
        }
        const isMobile = (this.initializedDevice == 'mobile' ? true : false);

        if ($('.strate-comparaison-formules').length) {
            $('#main-header').removeClass('main-header--bleu');
        }
        
        // Obfuscation des liens - gestion du click sur les buttons
        document.querySelectorAll('.main-header button[data-href]').forEach(
            $link => {
                $link.addEventListener(
                'click', function (evt) {
                        if (!document.getElementById('main-header').classList.contains('open') || isMobile) {
                            if (evt.target.getAttribute('target') === '_blank') {
                                var fenetre= window.open(evt.target.getAttribute('data-href'), '_blank');
                                if (fenetre)
                                    fenetre.focus();
                            } else {
                                location.href = evt.target.getAttribute('data-href');
                            }
                        }
                    }
            );
            }
        );
    }

    /**
     * Initialise le header mobile
     * 
     * @return {void}
     */
    initMobile()
    {
        this.destroyDesktop();
        this.initializedDevice = 'mobile';

        // Fonction à éxécuter au clique sur le toggler du menu
        this.mobileClickMenuTogglerHandler = evt => {
            if (this.$el.classList.contains('open')) {
                this.closeMobileMenu();
            } else {
                this.openMobileMenu();
            }
        };

        // Fonction à éxécuter à l'appuie sur une touche du clavier
        this.mobileKeyDownDocumentHandler = evt => {
            if (evt.key === 'Escape' && this.$el.classList.contains('open')) {
                this.closeMobileMenu(true);
            }
        };

        // Fonction à éxécuter au clique sur un lien du menu contenant des enfants
        this.mobileClickMainHeaderNavLinkWithChildrenHandler = evt => {
            evt.preventDefault();

            if (!evt.target.classList.contains('menu-item-column-title--not-link')) {
                const $item = evt.target.closest('.menu-item');
                this.openMobileSubmenu($item);
            }
        };

        // Fonction à éxécuter au clique sur le bouton retour
        this.mobileClickMainHeaderPhoneNavHandler = evt => {
            this.closeMobileMenu(true);
        };

        // Ouverture / Fermeture du menu au clique sur le toggler du menu
        this.$menuToggler.addEventListener('click', this.mobileClickMenuTogglerHandler);

        // Fermeture du menu à l'appuie sur la touche Escape
        document.addEventListener('keydown', this.mobileKeyDownDocumentHandler);

        // Fermeture sous-menu au clique sur le bouton retour
        this.$mainHeaderPhoneNav.querySelector('button').addEventListener('click', this.mobileClickMainHeaderPhoneNavHandler);

        // Ouverture sous-menu au clique sur un élément de menu contenant un sous-menu
        this.$mainHeaderNav.querySelectorAll('.menu-item-has-children > a,.menu-item-has-children > button').forEach(
            $link => {
                $link.addEventListener('click', this.mobileClickMainHeaderNavLinkWithChildrenHandler);
            }
        );
    }

    /**
     * Initialise le header desktop
     * 
     * @return {void}
     */
    initDesktop()
    {
        this.destroyMobile();
        this.initializedDevice = 'desktop';
    }

    /**
     * Détruit le header mobile
     * 
     * @return {void}
     */
    destroyMobile()
    {
        // On ré-autorise le scroll dans la page
        ScrollManager.preventScroll(false);

        // On enlève la contrainte du focus
        FocusManager.untrapFocus();

        // On ferme le menu s'il était ouvert pour éviter les erreurs
        this.$el.classList.remove('open');

        // Suppression des events bind lors de l'initialisation du header mobile
        this.$menuToggler.removeEventListener('click', this.mobileClickMenuTogglerHandler);
        document.removeEventListener('keydown', this.mobileKeyDownDocumentHandler);
        this.$mainHeaderPhoneNav.querySelector('button').removeEventListener('click', this.mobileClickMainHeaderPhoneNavHandler);
        this.$mainHeaderNav.querySelectorAll('.menu-item-has-children > a[href="#"]').forEach(
            $link => {
                $link.removeEventListener('click', this.mobileClickMainHeaderNavLinkWithChildrenHandler);
            }
        );

        this.$mainHeaderNav.querySelectorAll('.menu-item.open').forEach(
            $item => {
                $item.classList.remove('open');
            }
        );

        // Suppression des handlers définits lors de l'initialisation du header mobile
        this.mobileClickMenuTogglerHandler = null;
        this.mobileKeyDownDocumentHandler = null;
    }

    /**
     * Détruit le header desktop
     * 
     * @return {void}
     */
    destroyDesktop()
    {}

    /**
     * Ouvre le menu mobile
     * 
     * @return {void}
     */
    openMobileMenu()
    {
        this.$el.classList.add('open');

        // ScrollManager
        //     .scrollTo(0)
        //     .preventScroll(true);

        ScrollManager.preventScroll(true);
        
        FocusManager.trapFocus(
            this.$el.querySelectorAll('[data-trap-focus="main-header"]:not([data-not-trap-focus="main-header-0"]), [data-trap-focus="main-header-0"]')
        );
    }

    /**
     * Ferme le menu mobile
     * 
     * @param {boolean} onlyLastPanel Seulement le dernier panneau ouvert
     * 
     * @return {void}
     */
    closeMobileMenu(onlyLastPanel = false)
    {
        if (onlyLastPanel && this.$openedPanels.length > 0) {
            this.closeMobileSubmenu();
        } else {
            this.$el.classList.remove('open');

            this.$openedPanels.forEach(
                $panel => {
                    $panel.classList.remove('open');
                }
            );
            this.$openedPanels = [];

            // On remet le scroll de la page
            ScrollManager.preventScroll(false);

            // On enlève la contrainte du focus
            FocusManager.untrapFocus();
        }

        if (this.$openedPanels.length < 1) {
            this.$mainHeaderPhoneNav.classList.remove('show');
        }
    }
    
    /**
     * Ouvre un sous-menu mobile
     * 
     * @param {HTMLElement} $item 
     * 
     * @return {void}
     */
    openMobileSubmenu($item)
    {
        $item.classList.add('open');
        
        const depth = parseInt($item.querySelector(':scope > [data-depth]').dataset.depth);

        // Contraint le focus au panneau ouvert
        FocusManager.trapFocus(
            [
            ...Array.from(this.$el.querySelectorAll('[data-trap-focus="main-header"]')),
            ...Array.from($item.querySelectorAll(`[data-trap-focus="main-header-${depth + 1}"]:not(.menu-item-column-title--not-link)`)),
            ]
        );

        const $lastOpenedPanel = this.$openedPanels[this.$openedPanels.length - 1] || null;

        this.$openedPanels.push($item);

        // Changement du label du bouton retour
        if (depth > 0) {
            this.$mainHeaderPhoneNav.querySelector('span').innerText = $lastOpenedPanel.querySelector(':scope > a').innerText;
        } else {
            this.$mainHeaderPhoneNav.querySelector('span').innerText = this.$mainHeaderPhoneNav.querySelector('span').dataset.default;
        }

        this.$mainHeaderPhoneNav.classList.add('show');
    }

    /**
     * Ferme le dernier sous-menu mobile ouvert
     * 
     * @return {void}
     */
    closeMobileSubmenu()
    {
        const $item = this.$openedPanels.pop();
        $item.classList.remove('open');

        const $previousPanel = this.$openedPanels[this.$openedPanels.length - 1] || null;
        const depth = parseInt($item.querySelector(':scope > [data-depth]').dataset.depth);

        if (this.$openedPanels.length > 0) {
            // Contraint le focus au panneau précédent
            FocusManager.trapFocus(
                [
                ...Array.from(this.$el.querySelectorAll('[data-trap-focus="main-header"]')),
                ...Array.from($previousPanel.querySelectorAll(`[data-trap-focus="main-header-${depth + 1}"]:not(.menu-item-column-title--not-link)`)),
                ]
            );
        } else {
            FocusManager.trapFocus(
                this.$el.querySelectorAll('[data-trap-focus="main-header"]:not([data-not-trap-focus="main-header-0"]), [data-trap-focus="main-header-0"]')
            );
        }

        // Changement du label du bouton retour
        if (depth > 1) {
            const $previousPreviousPanel = this.$openedPanels[this.$openedPanels.length - 2] || null;
            this.$mainHeaderPhoneNav.querySelector('span').innerText = $previousPreviousPanel.querySelector(':scope > a').innerText;
        } else {
            this.$mainHeaderPhoneNav.querySelector('span').innerText = this.$mainHeaderPhoneNav.querySelector('span').dataset.default;
        }
    }
}
